import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimaYpsiliRight';
const args = {};

export class PetastiKentimaYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
